// extracted by mini-css-extract-plugin
export default {"bvnConsent":"BvnConsent_bvnConsent__bl4BR","bvnConsent__content":"BvnConsent_bvnConsent__content__RcJUO"};